import { Injectable } from '@angular/core';
import { Squad } from '@core/models/squad';
import { CustomerService } from '@core/services/customer/customer.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { FinishCustomerSquad, GetCustomerSquad } from './customer.actions';

@Injectable()
export class CustomerEffects {
  constructor(
    private actions$: Actions,
    private customerService: CustomerService,
    private store: Store
  ) {}

  getSquadInfo$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GetCustomerSquad),
        tap(() => {
          let squad: Squad;

          this.customerService.getSquadInfo().subscribe({
            next: (res) => {
              if (res && res.success) {
                squad = res.data;
              }
            },
            complete: () => {
              this.store.dispatch(FinishCustomerSquad({ squad }));
            },
          });
        })
      );
    },
    { dispatch: false }
  );
}
